"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const convertRGBtoHSL_1 = __importDefault(require("./convertRGBtoHSL"));
const convertHSLtoRGB_1 = __importDefault(require("./convertHSLtoRGB"));
const getContrast_1 = __importDefault(require("./getContrast"));
/*
  This utility takes two colors as arguments and darkens the primaryRGB value until
  it meets a W3C acceptable contrast ratio.
*/
const darkenRGBforAccessibleContrast = (
/*
 * Color to darken
 */
primaryRGB, 
/*
 * Color to check contrast against
 */
secondaryRGB, 
/*
 * Targeted contrast level
 * see: https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 */
contrastTarget = 4.5, 
/*
 * PRIVATE: used for function recursion
 */
_contrastDenominator = 1) => {
    const { h, s, l } = convertRGBtoHSL_1.default(primaryRGB);
    const { r, g, b } = convertHSLtoRGB_1.default({ h, s, l: l / _contrastDenominator });
    const contrast = getContrast_1.default(secondaryRGB, { r, g, b });
    if (!contrast) {
        throw Error('Contrast is undefined. Make sure that arguments are defined.');
    }
    if (contrast >= contrastTarget) {
        return { rgb: primaryRGB, contrast };
    }
    if (primaryRGB.r === 0 && primaryRGB.g === 0 && primaryRGB.b === 0) {
        throw Error('Color was darkened to black and accessible contrast was not achieved. Try lightening your secondaryRGB value.');
    }
    const inc = (contrastTarget - contrast) / 100;
    return darkenRGBforAccessibleContrast({ r, g, b }, secondaryRGB, contrastTarget, _contrastDenominator + inc);
};
exports.default = darkenRGBforAccessibleContrast;
